import React from "react";
import {
  Box,
  ListItem,
  Typography,
  Skeleton,
  ListItemText,
  CardMedia,
  Avatar,
} from "@mui/material";
import Translate from "../../../../../modules/Core/Components/Translate";

const BRAND = "#f05d32";

export default function ProductCartView(props) {
  const { component } = props;
  const product = component.props.product;

  const devHelper = component.getHelpers("dev");
  const filesUrl = component.getHelpers("env").get("files_url");
  const img_version = component.getHelpers("value").getValue("images-version");

  if (product) {
    var default_ingredients = product.item.ingredients;
    var selected_ingredients = product.values.ingredients;
    product.item.price = product.price;
    default_ingredients.forEach((default_ing) => {
      if (selected_ingredients.includes(default_ing.item._values.slug)) {
        default_ing.selected = true;
      } else {
        default_ing.selected = false;
      }
    });
  }

  return (
    <>
      {product && (
        <ListItem
          disablePadding
          sx={{
            py: 1.75,
            position: "relative",
            borderBottom: "1px solid rgba(0,0,0,0.06)",
            "&:last-of-type": {
              borderBottom: "none",
            },
          }}
        >
          <Box
            sx={{
              alignItems: "flex-start",
              display: "flex",
              width: "100%",
              gap: { xs: 1.5, sm: 2 },
            }}
          >
            <Box
              sx={{
                width: { xs: 88, sm: 100 },
                height: { xs: 88, sm: 100 },
                flexShrink: 0,
                position: "relative",
              }}
            >
              {!component.getData("default.imageReady", false) && (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="100%"
                  sx={{ borderRadius: "12px" }}
                />
              )}
              <CardMedia
                component="img"
                alt={devHelper.getObjectValue(product, "item.name")}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "12px",
                  bgcolor: "#f5f5f5",
                }}
                src={`${filesUrl}/products/images/${devHelper.getObjectValue(
                  product,
                  "item.slug",
                )}.png?v=${img_version}`}
                onError={(e) => {
                  e.target.src = `${filesUrl}/assets/images/not-found.png`;
                }}
                onLoad={() => {
                  component.setData({ "default.imageReady": true });
                }}
              />
              <Avatar
                sx={{
                  position: "absolute",
                  left: 6,
                  bottom: 6,
                  width: 24,
                  height: 24,
                  backgroundColor: BRAND,
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 700,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
              >
                {devHelper.getObjectValue(product, "amount")}
              </Avatar>
            </Box>

            <ListItemText
              sx={{ m: 0, minWidth: 0 }}
              primary={
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#1a1a1a",
                    lineHeight: 1.3,
                    mb: 0.5,
                  }}
                >
                  <Translate
                    entity="item"
                    eslug={devHelper.getObjectValue(product, "item.slug")}
                    scope="default"
                    slug="name"
                    auto
                  />
                </Typography>
              }
              secondary={
                <>
                  <Typography
                    component="div"
                    className={product.items ? "" : "line-clamp"}
                    sx={{
                      m: 0,
                      fontSize: 13,
                      color: "#6b6b65",
                      lineHeight: 1.4,
                    }}
                  >
                    {product.values.ingredients.map((slug, index) => {
                      return (
                        <React.Fragment key={`${slug}-${index}`}>
                          <Translate
                            entity="item"
                            eslug={slug}
                            scope="default"
                            slug="name"
                            auto
                          />
                          {index + 1 !== product.values.ingredients.length &&
                            ", "}
                        </React.Fragment>
                      );
                    })}
                    {product.items.map((item, index) => {
                      const { slug } = item;

                      return (
                        <React.Fragment key={`${slug}-${index}`}>
                          <Translate
                            entity="item"
                            eslug={slug}
                            scope="default"
                            slug="name"
                            auto
                          />
                          {index + 1 !== product.items.length && ", "}
                        </React.Fragment>
                      );
                    })}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 1,
                      fontSize: 15,
                      fontWeight: 700,
                      color: "#1a1a1a",
                      display: "block",
                    }}
                  >
                    {component
                      .getApp()
                      .priceFormater(
                        devHelper.getObjectValue(product, "price") *
                          devHelper.getObjectValue(product, "amount"),
                      )}
                  </Typography>
                </>
              }
              secondaryTypographyProps={{ sx: { mt: 0.5 }, component: "div" }}
            />
          </Box>
        </ListItem>
      )}
    </>
  );
}
